import React, { Fragment } from "react";

const DatosProveedor = ({data}) => {
  //let filename = data && data.url ? data.url.split('/') : ""
  return (
      <div className={`rd--file-card`}>
        <div className="rd--file-card__content">
          <div className="d-justify-space-between d-flex-column-m w100">                 
            <div className="documents_criteria_datostab">
                <label className="title-07">
                <span className="color-black">
                  <strong>{data.tipoDocumento +':'}</strong>
                </span>
                  {data.numDocumento} 
                </label>
            </div>
          </div>
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_datostab">
                <label className="title-07">
                <span className="color-black">
                  <strong>Razón Social:</strong>
                </span>
                  {data.nombreRazonSocial} 
                </label>
            </div>
          </div>
        </div>   
      </div>
  );
};

export default DatosProveedor;
